import { callApi } from '@/api/apibase'

export const createCustomerRegistrationRelation = function (registrationNumber) {
  const requestData = {
    registrationNumber: registrationNumber
  }
  return callApi(
    'POST', '/api/external/greencourse/CreateCustomerRegistrationRelation', requestData
  )
}
